import React, { useRef } from "react";
import { useCarouselWindow } from "./useCarouselWindow";

import {
  ChevronLeft,
  ChevronRight,
  TrendingUp,
  Cpu,
  Star,
  BookOpen,
} from "lucide-react";

const tools = [
  {
    name: "AI Smart Scanner",
    category: "AI Analysis",
    trend: "High Demand",
    price: "$499 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2FAI-scanners%2FAI-smartscanner.jpg?alt=media&token=ff24741f-03aa-4555-af75-bb810120fbf5",
  },

  {
    name: "Gold Expert Advisor",
    category: "Execution",
    trend: "Trending",
    price: "$79 / month",
    image:
      " https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Fexpertadvisor%2Fgold-ea.jpg?alt=media&token=a9de51c5-6b5b-4419-9b15-ee6067022f65",
  },

  {
    name: "ICT Trigger",
    category: "Indicator",
    trend: "High Demand",
    price: "$99 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Findicators%2Fict-trigger.jpg?alt=media&token=761036b9-cd7e-4988-bea2-16a2ea1ed301",
  },

  {
    name: "Algo Trading Robot",
    category: "Automation",
    trend: "Trending",
    price: "$50 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Falgorobots%2Falgorobot.jpg?alt=media&token=26a665fe-d1e3-453f-ac5c-672c0e815fa1",
  },
  {
    name: "Smart Money Indicator",
    category: "Indicators",
    trend: "Trending",
    price: "$75 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Findicators%2Fsmartmoneyindicator.jpg?alt=media&token=fe910617-da92-45bf-8163-779a7519279f",
  },
  {
    name: "Auto Risk Manager",
    category: "Risk Tools",
    trend: "Popular",
    price: "$49 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Friskmanagers%2Fauto-riskmanager.jpg?alt=media&token=5b11cfdf-242d-4ab6-b23d-75fa03b620a7",
  },
  {
    name: "Copy Trading Engine",
    category: "Execution",
    trend: "High Demand",
    price: "$199 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Fcopytrading-EA%2Fcopytrader.jpg?alt=media&token=d3a451a5-b8e1-46ef-bc9b-4b9e81b26250",
  },

  {
    name: "Double EMA Tracker",
    category: "Execution",
    trend: "High Demand",
    price: "$30 / month",
    image:
      "https://firebasestorage.googleapis.com/v0/b/million2trillion-4d06a.firebasestorage.app/o/marketplace%2Fexpertadvisor%2Fdouble-ematracker.jpg?alt=media&token=e9f75bd8-2cf1-4103-a717-1b0d01b45d16",
  },
];

// ---------------- BOOKS ----------------

const books = [
  {
    title: "Options as a Strategic Investment (5th Edition)",
    author: "Lawrence G. McMillan",
    category: "Options Trading / Derivatives",
    rating: 4.7,
    reviews: "1,011+",
    price: "$66.88",
    image: "https://m.media-amazon.com/images/I/81Mh0tWyfAL._SY522_.jpg",
    tag: "Options Trading Classic",
  },
  {
    title: "Trading in the Zone",
    author: "Mark Douglas",
    category: "Trading Psychology",
    rating: 4.5,
    reviews: "10,300+",
    price: "₹569",
    image: "https://m.media-amazon.com/images/I/61BDv28qJ9L._SY522_.jpg",
    affiliateLink: "https://amzn.to/4bhAWQv",
    tag: "Bestseller",
  },

  {
    title: "Futures & Options Blueprint",
    author: "Zebra Learn",
    category: "Derivatives & F&O",
    rating: 4.2,
    reviews: "573+",
    price: "₹1,690",
    image: "https://m.media-amazon.com/images/I/81GCTdRrJiL._SY522_.jpg",
    affiliateLink: "https://amzn.to/4qGLUUz",
    tag: "F&O Bestseller",
  },

  {
    title: "Swing Trading for Beginners",
    author: "A.Z. Penn",
    category: "Swing Trading / Technical Analysis",
    rating: 4.9,
    reviews: "56+",
    price: "$24.95",
    image: "https://m.media-amazon.com/images/I/710XCiBk+9L._SL1293_.jpg",
    tag: "Beginner Friendly",
  },

  {
    title: "Algorithmic and High-Frequency Trading",
    author: "Álvaro Cartea, Sebastián Jaimungal, José Penalva",
    category: "Algorithmic Trading",
    rating: 4.3,
    reviews: "66+",
    price: "₹7,110",
    image: "https://m.media-amazon.com/images/I/71Q9GFz5fGS._SY522_.jpg",
    affiliateLink: "https://amzn.to/3NBeVlS",
    tag: "Advanced Quant Book",
  },

  {
    title: "The Warren Buffett Way (Wiley Investment Classics)",
    author: "Robert G. Hagstrom",
    category: "Value Investing",
    rating: 4.7,
    reviews: "230+",
    price: "₹1,565",
    image: "https://m.media-amazon.com/images/I/71ih7ZRR83L._SY522_.jpg",
    affiliateLink: "https://amzn.to/3NJWw6f",
    tag: "Value Investing Bestseller",
  },
];

/* ================= COMPONENT ================= */

export default function TrendingMarketTools() {
  const {
    window: toolWindow,
    next: nextTool,
    prev: prevTool,
    pause: pauseTool,
    resume: resumeTool,
  } = useCarouselWindow({
    total: tools.length,
    visible: 4,
    interval: 2600,
  });

  const {
    window: bookWindow,
    next: nextBook,
    prev: prevBook,
    pause: pauseBook,
    resume: resumeBook,
  } = useCarouselWindow({
    total: books.length,
    visible: 5,
    interval: 3000,
  });

  return (
    <section className="w-full bg-[#0B0F19] py-24">
      <div className="mx-auto max-w-6xl px-4">
        {/* PAGE HEADER */}
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-white sm:text-3xl lg:text-3xl">
            Best <span className="text-blue-600">Marketplace Picks</span>
          </h2>
          <p className="mt-1 text-sm text-gray-400 sm:text-base">
            Discover verified tools, indicators, robots and top trading books.
          </p>
        </div>

        {/* DARK CONTAINER */}
        <div className="rounded-3xl bg-[#0B0F19] px-6 py-12 shadow-xl">
          {/* ================= TOOLS ================= */}
          <div className="mb-14">
            <div className="mb-6 flex items-center justify-between">
              <h3 className="text-base font-semibold text-white sm:text-lg">
                Trending Market Tools
              </h3>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    pauseTool(); // stop auto when user clicks
                    prevTool();
                  }}
                  className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
                >
                  <ChevronLeft size={18} />
                </button>

                <button
                  onClick={() => {
                    pauseTool();
                    nextTool();
                  }}
                  className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>

            <div
              onMouseEnter={pauseTool}
              onMouseLeave={resumeTool}
              className="flex gap-8 overflow-x-hidden"
            >
              {toolWindow.map((i) => {
                const tool = tools[i];
                return (
                  <div
                    key={i}
                    className="min-w-[260px] rounded-3xl border border-white/10 bg-[#12172A] transition hover:border-blue-500/40"
                  >
                    <div className="flex h-36 items-center justify-center rounded-t-3xl bg-black">
                      <img
                        src={tool.image}
                        alt={tool.name}
                        className="h-full object-contain"
                      />
                    </div>

                    <div className="p-5">
                      <div className="flex items-center gap-1 text-xs uppercase text-blue-400">
                        <Cpu size={14} /> {tool.category}
                      </div>

                      <h4 className="mt-2 text-lg font-semibold text-white">
                        {tool.name}
                      </h4>

                      <div className="mt-2 flex items-center gap-2 text-sm text-gray-400">
                        <TrendingUp size={16} /> {tool.trend}
                      </div>

                      <div className="mt-4 flex items-center justify-between">
                        <span className="font-semibold text-blue-400">
                          {tool.price}
                        </span>
                        <div className="flex items-center gap-1 text-yellow-400">
                          <Star size={14} /> 4.8
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ================= BOOKS ================= */}
          <div>
            <div className="mb-6 flex items-center justify-between">
              <h3 className="text-base font-semibold text-white sm:text-lg">
                Top Selling Books
              </h3>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    pauseBook();
                    prevBook();
                  }}
                  className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
                >
                  <ChevronLeft size={18} />
                </button>

                <button
                  onClick={() => {
                    pauseBook();
                    nextBook();
                  }}
                  className="rounded-full bg-gray-800 p-2 text-white hover:bg-gray-700"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>

            <div
              onMouseEnter={pauseBook}
              onMouseLeave={resumeBook}
              className="flex gap-6 overflow-x-hidden"
            >
              {bookWindow.map((i) => {
                const book = books[i];
                return (
                  <div
                    key={i}
                    className="min-w-[220px] rounded-2xl border border-white/10 bg-[#12172A] p-4 transition hover:border-yellow-400/40"
                  >
                    <div className="flex h-40 items-center justify-center">
                      <img
                        src={book.image}
                        alt={book.title}
                        className="max-h-full max-w-[120px] object-contain"
                      />
                    </div>

                    <h4 className="mt-3 line-clamp-2 text-sm font-semibold text-white">
                      {book.title}
                    </h4>

                    <p className="mt-1 text-xs text-gray-400">
                      by {book.author}
                    </p>

                    <div className="mt-3 flex items-center justify-between">
                      <span className="font-semibold text-yellow-400">
                        {book.price}
                      </span>
                      <div className="flex items-center gap-1 text-yellow-400">
                        <Star size={14} /> {book.rating}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
